import React from "react";
import {
    Checkbox,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow
} from "@mui/material";
import TableStyleUtility from "../TransactionUtility/connected-table-style-utility-bar";
import "../Transaction/connected-machine-spec-accordion"
function MachineSpecAccordion(props){
    const compBids = parseInt(props.transactions.compBids, 10);

    const checkSmartGradeCategory = function(category) {
        let result = false;
        props.domainDetails["MACHINE_SPEC_SMARTGRADE"].map((smartGradeCategory)=>{
            if(category === smartGradeCategory?.domainValue){
                result = true;
                return result;
            }
        })
        if(!result && props.transactions.bids.some((bid) => (bid.machSpecSmartgrade ==="Y"))){
            props.setBidsTextValue("machSpecSmartgrade", 'N', 'JD');
            {Array(compBids).fill(null).map((value, index) => (
                props.setBidsTextValue("machSpecSmartgrade", 'N', `C${index + 1}`)))}
        }
        return result;
    };
    return(
        <TableContainer variant="outlined">
            <Table
                striped
                sx={{ minWidth: 650 }}
                aria-label="simple table"
                size={"small"}
            >
                <TableStyleUtility />
                <TableBody>
                    {checkSmartGradeCategory(props.transactions.bids[0].category) && (
                    <TableRow
                        hover
                        key="Machine Spec Smart Grade"
                        id={"Machine Spec Smart Grade"}
                    >
                        <TableCell>
                            <InputLabel>{props.texts.SMART_GRADE}</InputLabel>
                        </TableCell>
                        <TableCell align="center">
                            <Checkbox
                                defaultChecked={props.transactions.bids[0].machSpecSmartgrade === "Y" ? true : false}
                                disabled={props.actionType.action === "view"}
                                onChange={(e) => {
                                if(e.target.checked){
                                    try {
                                        props.setBidsTextValue(
                                            "machSpecSmartgrade",
                                            "Y",
                                            "JD"
                                        );
                                    } catch (e) {}

                                }else{
                                    try {
                                        props.setBidsTextValue(
                                            "machSpecSmartgrade",
                                            "N",
                                            "JD"
                                        );
                                    } catch (e) {}
                                }
                            }}/>
                        </TableCell>
                        {Array(compBids)
                            .fill(null)
                            .map((value, index) => (
                                <TableCell align="center">
                                    <Checkbox
                                        defaultChecked={props.transactions.bids[index+1].machSpecSmartgrade === "Y" ? true : false}
                                        disabled={props.actionType.action === "view"}
                                      onChange={(e) => {
                                        if(e.target.checked){
                                            try {
                                                props.setBidsTextValue(
                                                    "machSpecSmartgrade",
                                                    "Y",
                                                    `C${index + 1}`
                                                );
                                            } catch (e) {}

                                        }else{
                                            try {
                                                props.setBidsTextValue(
                                                    "machSpecSmartgrade",
                                                    "N",
                                                    `C${index + 1}`
                                                );
                                            } catch (e) {}
                                        }
                                    }}/>
                                </TableCell>
                            ))}
                    </TableRow>)}

                    <TableRow
                        hover
                        key="Machine Spec Other Technology"
                        id={"Machine Spec Other Technology"}
                    >
                        <TableCell>
                            <InputLabel>{props.texts.OTHER_TECHNOLOGY}</InputLabel>
                        </TableCell>
                        <TableCell align="center">
                            <Checkbox
                                defaultChecked={props.transactions.bids[0].machSpecOther === "Y" ? true : false}
                                disabled={props.actionType.action === "view"}
                                onChange={(e) => {
                                if(e.target.checked){
                                    try {
                                        props.setBidsTextValue(
                                            "machSpecOther",
                                            "Y",
                                            "JD"
                                        );
                                    } catch (e) {}

                                }else{
                                    try {
                                        props.setBidsTextValue(
                                            "machSpecOther",
                                            "N",
                                            "JD"
                                        );
                                    } catch (e) {}
                                }
                            }}/>
                        </TableCell>
                        {Array(compBids)
                            .fill(null)
                            .map((value, index) => (
                                <TableCell align="center">
                                    <Checkbox
                                        defaultChecked={props.transactions.bids[index+1].machSpecOther === "Y" ? true : false}
                                        disabled={props.actionType.action === "view"}
                                        onChange={(e) => {
                                        if(e.target.checked){
                                            try {
                                                props.setBidsTextValue(
                                                    "machSpecOther",
                                                    "Y",
                                                    `C${index + 1}`
                                                );
                                            } catch (e) {}

                                        }else{
                                            try {
                                                props.setBidsTextValue(
                                                    "machSpecOther",
                                                    "N",
                                                    `C${index + 1}`
                                                );
                                            } catch (e) {}
                                        }
                                    }}/>
                                </TableCell>
                            ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}
export default MachineSpecAccordion;